export const shadowRegular = "0px 1px 3px 0px rgba(0, 0, 0, 0.05)";
export const shadowMedium = "0px 1px 3px 0px rgba(0, 0, 0, .15)";
export const shadowSemiStrong = "0 1px 5px 0px rgba(0, 0, 0, 0.05)"; // for class story cards (and cards in general)
export const shadowStrong = "0 1px 5px 0px rgba(0, 0, 0, 0.3)"; // reserved for modals and popover

export const shadowRegularHighContrast = "0px 1px 3px 0px rgba(0, 0, 0, .3)";
export const shadowMediumHighContrast = "0 1px 5px 0px rgba(0, 0, 0, 0.4)";
export const shadowSemiStrongHighContrast = "0 1px 5px 0px rgba(0, 0, 0, 0.45)"; // for class story cards (and cards in general)
export const shadowStrongHighContrast = "0 1px 5px 0px rgba(0, 0, 0, 0.5)"; // reserved for modals and popover
